import {handleStatsModalClick, handleHowToPlayModalClick} from "./events.js"
const howToPlayDialog = document.getElementById('howToPlayDialog');
const hasViewedIntro = localStorage.getItem("viewedIntro");

document.addEventListener("DOMContentLoaded", () => {
    document.getElementById('howToPlayCloseBtn').addEventListener('click', () => {
        howToPlayDialog.close();
    });

    document.getElementById('howToPlayBtn').addEventListener('click', () => {
        howToPlayDialog.showModal();
        handleHowToPlayModalClick()
    })

    howToPlayDialog.addEventListener('close', (e) => {
        localStorage.setItem('viewedIntro', true);
    })

    const winDialog = document.getElementById('winDialog');

    document.getElementById('shareCloseBtn').addEventListener('click', () => {
        winDialog.close();
    });
    document.getElementById('shareBtn').addEventListener('click', () => {
        winDialog.showModal();

        const rawHeader = localStorage.getItem("todayWinHeader");
        const rawEmojiGrid = localStorage.getItem("todayWinEmojiGrid");
        const footer = "\n\nPlay at https://turdle.blog";

        // Parse JSON strings back into actual unquoted strings
        const header = rawHeader ? JSON.parse(rawHeader) : "";
        const emojiGrid = rawEmojiGrid ? JSON.parse(rawEmojiGrid) : "";

        const winHeader = winDialog.querySelector("#win-header");
        const winGrid = winDialog.querySelector("#win-grid");
        const winFooter = winDialog.querySelector("#win-footer");

        winHeader.textContent = header;
        winGrid.textContent = emojiGrid;
        winFooter.textContent = footer;

        const copyBtn = winDialog.querySelector("#copyWinBtn");
        copyBtn.addEventListener("click", async () => {
            const copytext = `${header}\n${emojiGrid}${footer}`
            try {
                await navigator.clipboard.writeText(copytext);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        })
    });

    const statsDialog = document.getElementById('statsDialog');

    document.getElementById('statsCloseBtn').addEventListener('click', () => {
        statsDialog.close();
    });
    document.getElementById('statsBtn').addEventListener('click', () => {
        const totalWins = localStorage.getItem("totalWins");
        const currentStreak = localStorage.getItem("currentStreak");
        const bestStreak = localStorage.getItem("bestStreak");
        statsDialog.querySelector("#stats-total-wins").textContent = totalWins ? totalWins : "0"
        statsDialog.querySelector("#stats-current-streak").textContent = currentStreak ? currentStreak : "0"
        statsDialog.querySelector("#stats-best-streak").textContent = bestStreak ? bestStreak : currentStreak ? currentStreak : "0"
        statsDialog.showModal();
        handleStatsModalClick()
    })
})